import { FaCogs, FaGlobe, FaLightbulb, FaUsers } from "react-icons/fa";

const whyUs = {
  sub: "why choose us",
  heading: "Turning Dreams into AI Reality",
  content: "Experience the future with our cutting-edge AI solutions. Lorem ipsum dolor sit amet consectetur adipisicing elit.",
  points: [
    {
      id: 1,
      icon: <FaCogs />, // Cogs icon
      title: "AI Solutions",
      content: "Possimus laudantium sit perspiciatis maxime eius autem itaque.",
    },
    {
      id: 2,
      icon: <FaGlobe />, // Globe icon
      title: "Global Impact",
      content: "Possimus laudantium sit perspiciatis maxime eius autem itaque.",
    },
    {
      id: 3,
      icon: <FaLightbulb />, // Lightbulb icon
      title: "Innovation",
      content: "Possimus laudantium sit perspiciatis maxime eius autem itaque.",
    },
    {
      id: 4,
      icon: <FaUsers />, // Users icon
      title: "Collaboration",
      content: "Possimus laudantium sit perspiciatis maxime eius autem itaque.",
    },
  ],
};

export default whyUs;